import { render, staticRenderFns } from "./HeaderFranqueada.vue?vue&type=template&id=ec008754&scoped=true"
import script from "./HeaderFranqueada.vue?vue&type=script&lang=js"
export * from "./HeaderFranqueada.vue?vue&type=script&lang=js"
import style0 from "./HeaderFranqueada.vue?vue&type=style&index=0&id=ec008754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec008754",
  null
  
)

export default component.exports